<template>
  <div class="print-cancellation">
    <el-button
      type="primary"
      style="position: fixed; top: 15px; right: 460px; font-size: 18px"
      @click="saveHandler"
      v-show="mode != 'mobile'"
      v-loading="buttonLoad"
      >保存</el-button
    >
    <el-button
      type="warning"
      style="position: fixed;top: 15px;right: 355px;font-size:18px"
      v-show="mode != 'mobile'"
      @click="printHandler"
      >打印</el-button
    >
    <div id="print">
      <div
        class="print-part"
        v-for="(item, index) in info"
        :key="item.destroyId"
        :style="{
          width: '21cm',
          marginLeft: 'auto',
          marginRight: 'auto',
          minHeight: '29.7cm',
          padding: '0 1.5cm',
          boxSizing: 'border-box',
          marginBottom: setWrapBottom(item, index)
        }"
      >
        <p style="padding-top:2cm; text-align:center;">
          <span
            style="color:#ff0000; font-family:宋体; font-size:32pt; font-weight:900; letter-spacing:1.15pt; text-decoration:none"
            >中国化学工程集团有限公司</span
          >
        </p>
        <div style="border-bottom: 2pt solid #ff0000;margin:0 0 4pt"></div>
        <div style="border-bottom: 1pt solid #ff0000;margin:5pt 0"></div>
        <p
          style="text-align: right;font-size: 14pt;font-family: 仿宋;margin-top: 6pt;margin-bottom: 6pt"
        >
          {{ item.receiveNo }}
        </p>
        <p
          style="margin:0 0 10pt 0; orphans:0; text-align:center; widows:0;font-family:方正小标宋简体;font-size:22pt; font-weight:bold"
        >
          <span>关于注销</span>
          <span>{{ item.name }}</span>
          <span>等</span>
          <span>{{ item.num }}</span>
          <span>{{
            `人${
              item.type === "certUsers" ? "因公港澳通行证" : "公务普通护照"
            }的函`
          }}</span>
        </p>
        <!-- <p style="margin:0pt; orphans:0; text-align:justify; widows:0;line-height: 1">
          <span style="font-family:'Times New Roman'; font-size:1pt">&#xa0;</span>
        </p> -->
        <div
          style="margin:0pt; line-height: 2;font-family:宋体;font-size:16pt;font-weight:800;"
        >
          {{
            item.type === "certUsers"
              ? "国务院港澳事务办公室办证处："
              : "外交部领事司护照处："
          }}
        </div>
        <div
          class="show-content"
          v-if="isContent"
          style="
              margin: 0pt;
              text-align: justify;
              text-indent: 21pt;
              line-height:28pt;
              widows: 0;
              font-family: 宋体;
              overflow: hidden;
              font-size: 14pt;
            "
          contenteditable
        >
          <span>{{ item.letterContent }}</span>
        </div>
        <div
          contenteditable
          v-if="!isContent"
          class="letter-content"
          style="margin:0pt; orphans:0; text-align:justify; text-indent:21pt; widows:0;font-family:宋体;font-size:14pt;line-height: 1.5"
        >
          <span>我集团公司所属</span>
          <span>{{ item.companyName }}</span>
          <span>员工</span>
          <span>{{ item.name }}</span>
          <span>等</span>
          <span>{{ item.num }}</span>
          <span>人目前</span>
          <span class="print-reason">
            <span class=" input-reason-size">{{ item.reason }}</span>
            <span class=" input-reason-size">{{ reasonLastValue }}</span
            >。
          </span>
          <span>{{
            `按照因公${
              item.type === "certUsers" ? "证照" : "护照"
            }管理规定，现将其${
              item.type === "certUsers" ? "因公港澳通行证" : "公务普通护照"
            }注销`
          }}</span>
        </div>
        <p
          style="margin:1pt 0 0 0pt;orphans:0; text-align:justify; text-indent:21pt; widows:0;line-height: 1.5"
        >
          <span style="font-family:宋体; font-size:14pt">特此申请。</span>
        </p>
        <p
          style="margin:0 0pt 1pt 0pt;orphans:0;text-align:justify; text-indent:21pt; widows:0;line-height: 1.5"
        >
          <span style="font-family:宋体; font-size:14pt">名单如下：</span>
        </p>
        <div
          :style="{
            textAlign: 'center',
            marginLeft: '30px',
            marginBottom: setDivBtm(item.personList)
          }"
        >
          <div
            v-for="(row, tableIndex) in item.personList"
            :key="'row__' + tableIndex"
          >
            <table
              cellspacing="0"
              cellpadding="0"
              :style="{
                borderCollapse: 'collapse',
                marginBottom: setTableBtm(item.personList, tableIndex),
                width: '90%'
              }"
            >
              <tr style="height:24.55pt;font-weight:noramal; font-size:12pt">
                <td
                  style="border-bottom-color:#000000; border-bottom-style:solid; border-bottom-width:0.75pt; border-left-color:#000000; border-left-style:solid; border-left-width:0.75pt; border-right-color:#000000; border-right-style:solid; border-right-width:0.75pt; border-top-color:#000000; border-top-style:solid; border-top-width:0.75pt; padding-left:5.03pt; padding-right:5.03pt; vertical-align:middle; width:40pt;"
                >
                  <p style="margin: 0pt; text-align: center">
                    <span
                      style="
                          font-family: 宋体;
                          font-size: 12pt;
                          font-weight: bold;
                        "
                      >序号</span
                    >
                  </p>
                </td>
                <td
                  style="border-bottom-color:#000000; border-bottom-style:solid; border-bottom-width:0.75pt; border-right-color:#000000; border-right-style:solid; border-right-width:0.75pt; border-top-color:#000000; border-top-style:solid; border-top-width:0.75pt; padding-left:5.4pt; padding-right:5.03pt; vertical-align:middle; width:67.15pt"
                >
                  <p style="margin: 0pt; text-align: center">
                    <span
                      style="
                        font-family: 宋体;
                        font-size: 12pt;
                        font-weight: bold;
                      "
                      >姓 名</span
                    >
                  </p>
                </td>
                <td
                  style="border-bottom-color:#000000; border-bottom-style:solid; border-bottom-width:0.75pt; border-right-color:#000000; border-right-style:solid; border-right-width:0.75pt; border-top-color:#000000; border-top-style:solid; border-top-width:0.75pt; padding-left:5.4pt; padding-right:5.03pt; vertical-align:middle; width:31.75pt"
                >
                  <p style="margin: 0pt; text-align: center">
                    <span
                      style="
                        font-family: 宋体;
                        font-size: 12pt;
                        font-weight: bold;
                      "
                      >性别</span
                    >
                  </p>
                </td>
                <td
                  style="border-bottom-color:#000000; border-bottom-style:solid; border-bottom-width:0.75pt; border-right-color:#000000; border-right-style:solid; border-right-width:0.75pt; border-top-color:#000000; border-top-style:solid; border-top-width:0.75pt; padding-left:5.4pt; padding-right:5.03pt; width:114.65pt"
                >
                  <p style="margin: 0pt; text-align: center">
                    <span
                      style="
                        font-family: 宋体;
                        font-size: 12pt;
                        font-weight: bold;
                      "
                      >{{
                        `${item.type === "certUsers" ? "证照" : "护照"}号`
                      }}</span
                    >
                  </p>
                </td>
                <td
                  style="border-bottom-color:#000000; border-bottom-style:solid; border-bottom-width:0.75pt; border-right-color:#000000; border-right-style:solid; border-right-width:0.75pt; border-top-color:#000000; border-top-style:solid; border-top-width:0.75pt; padding-left:5.4pt; padding-right:5.03pt; vertical-align:middle; width:117.3pt"
                >
                  <p style="margin: 0pt; text-align: center">
                    <span
                      style="
                        font-family: 宋体;
                        font-size: 12pt;
                        font-weight: bold;
                      "
                      >有效期</span
                    >
                  </p>
                </td>
              </tr>
              <tr
                style="height:27.75pt;font-weight:noramal;font-size:14pt "
                v-for="person in row"
                :key="person.personInfoId"
              >
                <td
                  style="border-bottom-color:#000000;border-bottom-style:solid; border-bottom-width:0.75pt; border-left-color:#000000; border-left-style:solid; border-left-width:0.75pt; border-right-color:#000000; border-right-style:solid; border-right-width:0.75pt; padding-left:5.03pt; padding-right:5.03pt; vertical-align:middle; width:16.4pt"
                >
                  <p style="margin: 0pt; text-align: center">
                    <span style="font-family: 宋体; font-size: 12pt">{{
                      person.orderNo
                    }}</span>
                  </p>
                </td>
                <td
                  style="border-bottom-color:#000000;border-bottom-style:solid; border-bottom-width:0.75pt; border-right-color:#000000; border-right-style:solid; border-right-width:0.75pt; padding-left:5.4pt; padding-right:5.03pt; vertical-align:middle; width:67.15pt"
                >
                  <p style="margin: 0pt; text-align: center">
                    <span style="font-family: 宋体; font-size: 12pt">{{
                      person.name
                    }}</span>
                  </p>
                </td>
                <td
                  style="border-bottom-color:#000000; border-bottom-style:solid; border-bottom-width:0.75pt; border-right-color:#000000; border-right-style:solid; border-right-width:0.75pt; padding-left:5.4pt; padding-right:5.03pt; vertical-align:middle; width:31.75pt"
                >
                  <p style="margin: 0pt; text-align: center">
                    <span
                      style="font-family: 宋体; font-size: 12pt"
                      v-if="person.name && person.sex"
                      >{{ person.sex == "M" ? "男" : "女" }}</span
                    >
                  </p>
                </td>
                <td
                  style="border-bottom-color:#000000; border-bottom-style:solid; border-bottom-width:0.75pt; border-right-color:#000000; border-right-style:solid; border-right-width:0.75pt; padding-left:5.4pt; padding-right:5.03pt; vertical-align:middle; width:114.65pt"
                >
                  <p style="margin: 0pt; text-align: center">
                    <span style="font-family: 宋体; font-size: 12pt">{{
                      person.passportNo
                    }}</span>
                  </p>
                </td>
                <td
                  style="border-bottom-color:#000000;border-bottom-style:solid; border-bottom-width:0.75pt; border-right-color:#000000; border-right-style:solid; border-right-width:0.75pt; padding-left:5.4pt; padding-right:5.03pt; vertical-align:middle; width:117.3pt"
                >
                  <p style="margin: 0pt; text-align: center">
                    <span
                      style="font-family: 宋体; font-size: 12pt"
                      v-if="person.passportNo"
                      >{{ person.validityDate }}</span
                    >
                  </p>
                  <!-- <p style="margin:0pt; orphans:0; widows:0"> -->
                </td>
              </tr>
            </table>

            <!-- 表格分页后 上面留白距离太小 加个透明盒子占位 用于增加表格上边距 -->
            <div
              v-if="tableIndex !== item.personList.length - 1"
              style="height: 40px; background: transparent; width: 100%"
            ></div>
          </div>
        </div>
        <p style="orphans:0; text-align:right; widows:0">
          <img
            src="./wanglei.png"
            style="vertical-aligen: middle;height: 47pt;"
            alt=""
          />
        </p>

        <p style="orphans:0; text-align:right; widows:0">
          <input
            type="text"
            @change="yearChange"
            style="outline:none;font-size: 14pt;border:none;text-align:center;margin:0 5pt 0 0;width: 33pt;font-weight:bold"
            v-model="editYear"
          />年
          <input
            type="text"
            @change="monthChange"
            style="outline:none;font-size: 14pt;border:none;text-align:center;margin:0 5pt 0 0;width: 20pt;font-weight:bold"
            v-model="editMonth"
          />月
          <input
            type="text"
            @change="dayChange"
            style="outline:none;font-size: 14pt;border:none;text-align:center;margin:0 5pt 0 0;width: 20pt;font-weight:bold"
            v-model="editDay"
          />日
        </p>
        <p
          style="margin:0 0 0 21pt; orphans:0; text-align:justify; widows:0;font-family:宋体; font-size:14pt; font-weight:bold"
        >
          <span>联系人:</span>
          <input
            type="text"
            v-model="contact"
            style="outline:none;font-size: 14pt;border:none;margin: 10pt;width: 185pt;font-weight:bold"
          />
          <br />
          <span>电话：</span>
          <input
            type="text"
            style="outline:none;font-size: 14pt;border:none;margin: 10pt;width: 185pt;font-weight:bold"
            v-model="tel"
          />
          <br />
          <span>传真：</span>
          <input
            type="text"
            style="outline:none;font-size: 14pt;border:none;margin: 10pt;width: 185pt;font-weight:bold"
            v-model="fax"
          />
        </p>
      </div>
    </div>
    <div style="text-align: center">
      <span
        >版权所有：中国化学工程集团(股份)有限公司 |
        <a href="https://beian.miit.gov.cn/" target="_blank"
          >京ICP备17025820号-5</a
        >
        | 版本号：{{ this.versionNumber }}<!-- | 技术支持：北京赛鼎科技有限公司 --></span
      >
    </div>
  </div>
</template>
<script>
import Api from "../../api/foreign/foreign_cancellation";
import printjs from "print-js";
import DateUtils from "../../util/date";
import _ from "lodash";
import { mapGetters } from "vuex";
const curDate =
  new Date().getDate() >= 10
    ? new Date().getDate()
    : `0${new Date().getDate()}`;
const curMonth =
  new Date().getMonth() + 1 >= 10
    ? new Date().getMonth() + 1
    : `0${new Date().getMonth() + 1}`;
const curYear = new Date().getFullYear();
import encipherUtil from "@/util/encipher";
let encipher = new encipherUtil();
export default {
  name: "printCancellation",
  computed: {
    ...mapGetters(["versionNumber"])
  },
  props: {
    mode: {
      type: String,
      default: "PC"
    }
  },
  data() {
    return {
      editYear: curYear,
      editMonth: curMonth,
      month: "",
      editDay: curDate,
      buttonLoad: false,
      isContent: null,
      contact: "庄静",
      changeDateList: [],
      tel: "59765667",
      fax: "59765661",
      personList: [],
      info: [],
      wrapBtm: "",
      pageSize: 16,
      pageSizeN: 28,
      reasonLastValue: "劳动关系"
    };
  },
  methods: {
    yearChange(e) {
      let reg = /^(19|20)[0-9]{2}$/;
      let str = reg.test(e.target.value);
      if (!str) {
        this.$message.error("输入的年份不合格，请重新输入");
        this.editYear = "";
      }
    },
    monthChange(e) {
      let reg = /^(0[1-9])|(1[0-2])$/;
      let str = reg.test(e.target.value);
      if (!str) {
        this.$message.error("输入的月份不合格，请重新输入");
        this.editMonth = "";
      }
    },
    dayChange(e) {
      let reg = /^(0[1-9])|(1[0-9])|(2[0-9])|(3[0-1])$/;
      let str = reg.test(e.target.value);
      if (!str) {
        this.$message.error("输入的日期不合格，请重新输入");
        this.editDay = "";
      }
    },
    //保存
    saveHandler() {
      let allSpan = !this.isContent
        ? document.querySelectorAll(".letter-content span")
        : document.querySelectorAll(".show-content span");
      if (!allSpan.length) {
        allSpan = !this.isContent
          ? document.querySelectorAll(".letter-content")
          : document.querySelectorAll(".show-content");
      }
      let str = "";
      for (let i = 0; i < allSpan.length; i++) {
        str += allSpan[i].innerText;
      }
      let query = {
        destroyId: this.$route.query.id, //id
        letterContent: str, //内容
        openTime: `${this.editYear}-${this.editMonth}-${this.editDay}`, //函件日期
        letterContact: this.contact, //函件联系人
        letterPhone: this.tel, //函件电话
        letterFax: this.fax //函件传真
      };
      this.buttonLoad = true;
      Api.saveDestoryLetter(query)
        .then(res => {
          if (res.code == 1) {
            this.$message.success("保存成功");
            this.buttonLoad = false;
          }
        })
        .catch(error => {
          this.$message.error(error);
          this.buttonLoad = false;
        });
    },
    // 设置包含了div以及table父元素的下边距
    setWrapBottom(ele, sy) {
      let bottom =
        sy !== this.info.length - 1 && ele.personList.length > 1
          ? "19cm"
          : "0cm";
      return bottom;
    },
    // 设置table的下边距
    setTableBtm(data, index) {
      let bottom;
      if (data.length > 1 && index === 0) {
        bottom = "280px";
      } else {
        bottom = "50px";
      }
      return bottom;
    },
    //设置包含了table父元素的margin-bottom
    setDivBtm(ele) {
      let bottom = ele.length === 1 ? "0" : "50px";
      return bottom;
    },
    printHandler() {
      let destroyId = {};
      this.$forceUpdate();
      let changeDateList = this.info.map((item, index) => {
        let destroyIds = this.$route.query.id.split(",");
        destroyId = destroyIds[index];
        return {
          destroyId,
          openTime: `${item.editYear}-${item.editMonth}-${item.editDay}`
        };
      });

      let obj = { openTimeList: changeDateList };
      Api.editOpenTime(obj).then(res => {});
      printjs({
        printable: "print",
        type: "html",
        scanStyles: false,
        css: ["/static/print/print.css"]
      });
    },
    getList(personList) {
      let firstItem, pageNum, list;
      //第一种情况:不满13条
      if (personList.length && personList.length < this.pageSize) {
        firstItem = personList.splice(0, this.pageSize);
        list = [firstItem];
      }
      //第二种情况超过13条
      if (
        (personList.length && personList.length > this.pageSize) ||
        (personList.length && personList.length === this.pageSize)
      ) {
        firstItem = personList.splice(0, this.pageSize);
        list = [firstItem];
        pageNum = personList.length;
        for (let i = 0; i < pageNum; i++) {
          let myxArr = personList.slice(
            i * this.pageSizeN,
            this.pageSizeN * (i + 1)
          );
          if (myxArr.length) list.push(myxArr);
        }
      }
      return list;
    }
  },

  mounted() {
    let list = [];
    let dateList = JSON.parse(encipher.getSessionStorageAES("dateList"));
    if (this.$route.query.id) {
      let ids = this.$route.query.id.split(",");
      ids.forEach(val => {
        Api.addGenerateLog({ id: val });
      });
      Promise.all(
        ids.map(a => {
          return Api.detail({ destroyId: a, type: "2" });
        })
      ).then(res => {
        res.forEach((a, index) => {
          if (a.data.destroyPassport) {
            // this.isContent = a.data.destroyPassport.letterContent
            //   ? a.data.destroyPassport.letterContent
            //   : null;
            this.isContent = null;
            this.contact = a.data.destroyPassport.letterContact
              ? a.data.destroyPassport.letterContact
              : "庄静";
            this.tel = a.data.destroyPassport.letterPhone
              ? a.data.destroyPassport.letterPhone
              : "59765667/13801358945";
            this.fax = a.data.destroyPassport.letterFax
              ? a.data.destroyPassport.letterFax
              : "59765661";
            if (a.data.destroyPassport && a.data.destroyPassport.openTime) {
              this.editYear = a.data.destroyPassport.openTime.substr(0, 4);
              this.editMonth = a.data.destroyPassport.openTime.substr(5, 2);
              this.editDay = a.data.destroyPassport.openTime.substr(8);
            } else {
              this.editYear = curYear;
              this.editMonth = curMonth;
              this.editDay = curDate;
            }
          }
          if (a.data.certUsers && a.data.certUsers.length) {
            const num = a.data.certUsers.length;
            const name = a.data.certUsers[0]?.name;
            a.data.certUsers.forEach(
              (person, idx) => (person.orderNo = idx + 1)
            );
            let personList = a.data.certUsers;
            const list = this.getList(personList);
            console.log("list:", list);
            if (list.length) {
              const { year, month, day } = dateList[index];
              this.info.push({
                ...a.data.destroyPassport,
                num,
                name,
                type: "certUsers",
                personList: list,
                // reason: `${firstItem[0].reason},公司已与其解除`
                reason: `${list[0][0].reason},公司已与其解除`,
                editYear: year || this.editYear,
                editMonth: month || this.editMonth,
                editDay: day || this.editDay
              });
            }
          }
          if (a.data.users && a.data.users.length) {
            const num = a.data.users.length;
            const name = a.data.users[0]?.name;
            a.data.users.forEach((person, idx) => (person.orderNo = idx + 1));
            let personList = a.data.users;
            const list = this.getList(personList);
            console.log("list:", list);
            if (list.length) {
              const { year, month, day } = dateList[index];
              this.info.push({
                ...a.data.destroyPassport,
                name,
                num,
                personList: list,
                // reason: `${firstItem[0].reason},公司已与其解除`
                reason: `${list[0][0].reason},公司已与其解除`,
                editYear: year || this.editYear,
                editMonth: month || this.editMonth,
                editDay: day || this.editDay
              });
            }
          }

          // if (list.length < 2) {
          //   this.info.push({
          //     ...a.data.destroyPassport,
          //     personList: list,
          //     reason: `${firstItem[0].reason},公司已与其解除`
          //   });
          // }
          // if (list.length > 1) {
          //   this.info.push({
          //     ...a.data.destroyPassport,
          //     personList: list,
          //     reason: `${firstItem[0].reason},公司已与其解除`
          //   });
          // }
        });
        console.log("this.info:", this.info);
        // this.info.forEach((item, index, arr) => {
        //   arr[index].editYear = dateList[index].year
        //     ? dateList[index].year
        //     : this.editYear;
        //   arr[index].editMonth = dateList[index].month
        //     ? dateList[index].month
        //     : this.editMonth;
        //   arr[index].editDay = dateList[index].day
        //     ? dateList[index].day
        //     : this.editDay;
        // });
      });
    }
  }
};
</script>
<style lang="scss" scoped>
@import "../../assets/css/global.scss";
@import "../../assets/css/documentEdit.css";
input[type="text"] {
  border-bottom: 1pt solid #000 !important;
}
</style>
